export default __webpack_public_path__ + "static/media/instagram 2.320ab27d.svg";